import { EmpresaFilters } from "../types/empresa";
import { useState } from "react";
import { Filters } from '../components/EmpresaComponents/Filters';
import { UploadEmpresaButton } from '../components/UtilitiesComponents/UploadEmpresaButton';
import { EmpresasTable } from '../features/empresas/EmpresaList/EmpresasTable';
import { EmpresaCounter } from "src/features/empresas/EmpresasCounter/components"; 
import { useSelector } from "react-redux";
import { selectCurrentUserRole } from "src/api/auth/authSlice";
import { ROLES } from "src/utils/enums";
import useDebounce from '../hooks/useDebounce';

export function EmpresasList() {
    const userRole = useSelector(selectCurrentUserRole);

    const [filtersValues, setFilters] = useState<EmpresaFilters>({
        fechaInicio: "",
        fechaFin: "",
        estado: "",
        prospectador: "",
        frecuenciaVisita: "",
    });

    const filters = useDebounce(filtersValues, 3000);

    return (
        <div className="h-full flex flex-col">
            <div className="flex h-14 p-2 m-2">
                <UploadEmpresaButton />
            </div>

            <div className="flex items-center px-3 py-1 gap-x-5 overflow-auto">
                <div className={userRole == ROLES.ADMIN ? "border border-gray-500 rounded p-2 bg-slate-100" : ""}>
                    <Filters 
                        filters={filtersValues}
                        setFilters={setFilters}/>
                </div>

                {userRole == ROLES.ADMIN && (
                <EmpresaCounter
                    fechaInicio={filters.fechaInicio ?? ""}
                    fechaFin={filters.fechaFin ?? ""}
                    prospectadorId={filters.prospectador ?? "0"}/>
                )}
            </div>

            <EmpresasTable
                filters={filters} />
        </div>
    );
}